"use strict";

require("./index.less");
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/lib/style/index.js
// module id = 1309
// module chunks = 0